<template lang="html">
  <div class="container">

    <div class="header">
      <div class="top">
        <p  @click="fn(1)" :class="{ 'yes': tabType == 1 }">我的项目</p>
        <p  @click="fn(2)" :class="{ 'yes': tabType == 2 }">我的阿米巴</p>
      </div>
    </div>


    <!-- 我的项目 -->
    <div class="percent"  v-if="tabType == 1 && !detailType">

      <ul class="field-wrappwe three">

        <li class="field-item">
          <p class="item-value"> <span class="symbol">¥</span>{{ projectData.all_back_money == undefined ? '' :  Number(projectData.all_back_money).toFixed(2) }}<span class="unit">(万)</span></p>
          <p class="item-name ">已回款</p>
        </li>

        <li class="field-item">
          <p class="item-value"> <span class="symbol">¥</span>{{  projectData.all_money == undefined ? '' : Number(projectData.all_money).toFixed(2) }}<span class="unit">(万)</span></p>
          <p class="item-name ">已签约</p>
        </li>

        <li class="field-item">
          <p class="item-value"> <span class="symbol">¥</span>{{ projectData.have_wait_money == undefined ? '' : Number(projectData.have_wait_money).toFixed(2) }}<span class="unit">(万)</span></p>
          <p class="item-name ">已开发票待回款</p>
        </li>

      </ul>


      <div class="list-wrapper">


        <nodata v-if="!projectData.data.length"></nodata>
        <div class="list-item" v-for=" item in projectData.data" @click="toDetail(1,item)">

          <div class="row text">
            <span>{{item.create_date}}</span>
            <span class="active">{{ item.status}}</span>
          </div>

          <div class="row text">
            <span>{{ item.name }}</span>
          </div>

          <div class="row">

            <div class="row-item">
              <p class="item-value"> <span class="symbol">¥</span>{{ (item.b_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
              <p class="item-name">已回款金额</p>
            </div>

            <div class="row-item center">
              <p class="item-value">{{ item.end_date || '未设置' }}</p>
              <p class="item-name">计划结束时间</p>
            </div>

            <div class="row-item">
              <p class="item-value charge">{{ item.sale }}</p>
              <p class="item-name">负责人</p>
            </div>

          </div>
        </div>

      </div>

    </div>
    <my-detail v-if="detailType == 1" @on-return="showList" :data="detailData"></my-detail>


    <!-- 我的阿米巴 -->
    <div class="percent1"  v-if="tabType == 2 && !detailType">
      <ul>
        <nodata v-if="!amoebaData.length"></nodata>
        <li v-for="item in amoebaData" @click="toDetail(2,item)">
          <h2>
            {{item.project_name}}
          </h2>
          <p class="group">负责人:&nbsp;{{item.name}}</p>
          <p class="group">小组：&nbsp;{{item.item_id == 0 ? '未指派' : group[item.item_id]}}</p>
          <p class="txtleft1">
            <span class="small">¥</span>
            {{(item.price/10000).toFixed(2)}}
            <span class="small">(万)</span>
            <br>
            <span class="pre">项目金额</span>

          </p>
          <p class="txtright1">
            {{item.cost}}h
            <br>
            <span class="pre">总耗时(h)</span>
          </p>

          <p class="time">{{item.created_at.split(' ')[0]}} &nbsp; 完成度：{{item.complete}}%</p>
        </li>
      </ul>
    </div>
    <AmbDetail v-if="detailType == 2" @on-return="showList" :data="detailData"></AmbDetail>
  </div>
</template>

<script>
  import '../assets/css/drillStyle.css'
  import nodata from './public/nodata'
  import myDetail from './MyDetail.vue'
  import AmbDetail from './AmbDetail.vue'

  export default {
    components:{
      nodata,
      myDetail,
      AmbDetail,
    },
    data () {
      return {
        index:1,
        tabType:1,
        detailType:null,
        detailData:[], //查看详情的数据

        group:[],
        projectData:{data:[]},
        amoebaData:[],

      }
    },
    methods: {
      fn (type) {
        if ( type == 2 && this.index == 1 ) {
          this.$notice.loading()
          this.$http.getMyAmoeba().then ( res => {
            this.index = 2
            this.unit = res.data.unit
            this.group = res.data.item
            this.amoebaData = res.data.amoeba
            this.$notice.loading(false)
          })
        }
        this.tabType = type
        this.detailType = null
      },

      toDetail (type,item) { //查看详情 转换状态
        this.detailType = type
        this.detailData = item
      },
      showList () {
        this.detailType = null
      }
    },
    created () {
      this.$notice.loading()
      if (this.$route.params.type) {
        this.index == 2
        this.$notice.loading(false)
        this.$http.getMyAmoeba().then ( res => {
          this.unit = res.data.unit
          this.group = res.data.item
          this.amoebaData = res.data.amoeba
        })
        this.tabType = this.$route.params.type
      }
      this.$http.getMyProject().then( res => {
        this.$notice.loading(false)
        this.projectData = res.data
      })
    },
  }

</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fafafa;
    font-family: PingFangSC-Regular;
  }
  .header{
    width: 100%;
    background: #fff;
    padding-top: 0.15625rem;
    padding-bottom: 0.1875rem;
    border-bottom: 1px solid rgba(204,204,204,.4);
  }
  .yes{
    background: #5483D2;
    color: #fff;
  }
  .top{
    width: 6.40625rem;
    color: #000;
    border: 1px solid #5483D2;
    font-size: 0.4375rem;
    margin: auto;
    border-radius: 0.09375rem;
    /*margin-bottom: 0.25rem;*/
    height: 0.875rem;
  }
  .top p{
    float: left;
    width:50%;
    text-align: center;
    border-right: 1px solid #5483D2;
    padding: 0.125rem;
    height: 100%;
  }
  .top p:last-child{
    border:0;
  }
  .percent1{
    color: #000;
    position: relative;
    width: 100%;
    background: #fff;
    margin-bottom: 0.1875rem;
  }
  .percent1 ul{
    width: 100%;
    margin: auto;
    background: #fafafa;
    height: 100%;
  }
  .percent1 ul li{
    position: relative;
    width: 95%;
    margin: auto;
    background: #fff;
    margin-bottom: 0.15625rem;
    border-radius: 0.09375rem;
    height: 4.1875rem;
  }
  .percent1 ul li h2{
    color: #333333;
    font-size: 0.4375rem;
    font-weight: 500;
    margin-top: 0.15625rem;
    border-left: 0.09375rem solid #5483D2;
    padding-left: 0.5rem;
    height: 0.9375rem;
    line-height: 1.09375rem;
    margin-bottom: 0.09375rem;
    border-top-left-radius: 0.09375rem;
  }


  .txtleft{
    width: 49%;
    float: left;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
    clear: both;

  }
  .txtright{
    width: 49%;
    float: right;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
  }
  .txtleft1{
    width: 49%;
    float: left;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
    clear: both;
    margin-top: 0.40625rem;
  }
  .txtright1{
    width: 49%;
    float: right;
    text-align: center;
    color: #5483D2;
    font-size:0.5rem;
    margin-top: 0.40625rem;
  }
  .pre{
    font-size: 0.375rem;
    color: #333;
    display: block;
  }

  .small{
    font-size: 0.34375rem;
    display: inline-block;
    color: #5483D2;
  }
  .spantxt{
    position: absolute;
    right: 0.375rem;
    font-size: 0.3125rem;
    color: #5483D2;
  }

  .group{
    color: #333;
    font-size: 0.4375rem;
    padding-left: 0.59375rem;
    margin-top: -0.125rem;
    margin-bottom: 0.0625rem;
    width: 50%;
    float: left;
  }
  .time{
    width: 100%;
    position: absolute;
    bottom: 0.21875rem;
    left: 0.59375rem;
    color: #666;
    font-size: 0.3125rem;
  }
  .tips {
    padding-top: 36.21%;
    background-color: #fff;
    font-size: 0.375rem;
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #5483D2;
    font-size: 0.4375rem;
  }
  .tips img {
    width: 5.28125rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/MyProject.vue